import { Chip } from "@mui/material";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import Progress from "components/stamp/progress";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme, props) => ({
  stamp: {
    "& .stamp-wrap": {
      background: "#F6F6F6",
      padding: `0 ${rem(20)} ${rem(15)}`,
      "& .stamp-item": {
        padding: `${rem(35)} 0 ${rem(38)}`,
        borderRadius: rem(16),
        boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.05)",
        "& .title": {
          display: "block",
          padding: `0 ${rem(20)} 0 ${rem(30)}`,
          "& .text": {
            position: "relative",
            display: "flex",
            direction: "ltr",
            textIndent: 0,
            alignItems: "center",
            "& .prm": {
              fontSize: rem(18),
              fontWeight: 800,
              lineHeight: rem(24),
            },
            "& .MuiChip-root": {
              fontSize: rem(10),
              marginLeft: rem(8),
              color: theme.palette.primary.main,
              borderColor: theme.palette.primary.main,
              padding: `${rem(2)} ${rem(8)} 0`,
              height: rem(16),
            },
            "&::after": {
              content: "''",
              position: "absolute",
              top: "50%",
              right: 0,
              width: rem(20),
              height: rem(20),
              marginTop: rem(-10),
              backgroundImage: `url(${
                process.env.PUBLIC_URL
              }/images/icon/arrow-main-gray.svg)`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: `${rem(20)} ${rem(20)}`,
            },
          },
          "& .store": {
            marginTop: rem(5),
            lineHeight: rem(16),
          },
        },
        "& .type-stamp": {
          margin: `${rem(17)} 0 0 ${rem(30)}`,
          height: rem(48),
          "& img:last-child": {
            marginRight: rem(30),
          },
        },
        "& .type-gauge": {
          padding: `0 ${rem(27)}`,
        },
        "& img": {
          height: rem(48),
        },
        "& .icon": {
          width: rem(48),
          height: rem(48),
          transform: "translate(-24px,-50%)",
        },
        "& .MuiLinearProgress-root": {
          margin: `${rem(36)} 0 ${rem(18)}`,
        },
      },
    },
  },
}));
export default function Stamp(props) {
  const classes = useStyles();
  const history = useHistory();

  const { data } = useSelector((state) => state.home);

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const iconYn = props.iconYn;

  const [stampList, setStampList] = useState([]);

  useEffect(() => {
    if (data.stampList) setStampList(data.stampList);
  }, [data]);

  const stampRender = (item) => {
    let render = [];
    let dailyMaxCount = item.accCount;

    for (let i = 0; i < item.totalMaxCount; i++) {
      if (dailyMaxCount > 0) {
        render.push(<img src={item.actvImgUrl} key={i} />);
        dailyMaxCount--;
      } else render.push(<img src={item.dsblImgUrl} key={i} />);
    }

    return render;
  };

  return (
    <div className={classes.stamp}>
      <div className="stamp-wrap">
        <ul>
          {/* {stampClubList.length == 0 && stampList.length == 0 && (
        <>
          <div className="nodata">
            <Box className="illust">
              <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
            </Box>
            <p className="color-info">진행중인 스탬프 행사가 없습니다</p>
          </div>
        </>
      )} */}
          {stampList.map((item, i) => (
            <li
              key={i}
              className="stamp-item"
              onClick={() => {
                history.push({
                  pathname: `/stamp/detail/${item.seq}`,
                  props: { seq: item.seq, storeCode: storeCode },
                });
              }}
            >
              <div className="title">
                <div className="text">
                  <div className="prm">{item.promotionSubName}</div>
                  <Chip
                    label={Number(item.dday) >= 0 ? "D-" + item.dday : "종료됨"}
                    variant="outlined"
                  />
                  {/* <span className="cnt" style={{ color: item.clr }}>
                    {item.accCount}/{item.totalMaxCount}
                  </span> */}
                </div>

                <div className="store">{item.storeName}</div>
              </div>

              {item.stampFlag == "1" ? (
                <div className="type-gauge">
                  <Progress item={item} iconYn="Y" />
                </div>
              ) : (
                <div className="type-stamp">{stampRender(item)}</div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
